import React from 'react';
import PropTypes from 'prop-types';
import { DetailPanelData } from "../Common/DetailPanel"

const LeakMonitoringDevice = ({
    data: {
        assetTypeId = null,
        leakMonitorDeviceName = '',
        leakMonitorDeviceDetectionLimit = '',
        leakMonitorDeviceAlarmSetPoint = '',
        leakMonitorDeviceConcentrationMonitorType = '',
        leakMonitorDeviceConcentrationManufacturer = '',
        leakMonitorDeviceSensorType = '',
        leakMonitorDeviceNumberOfSensors = '',
    } = {}
}) => {
    if (assetTypeId !== 2) return null;
return (
    <>
        <DetailPanelData id='DeviceTypeHeader' title="DEVICE TYPE" data={leakMonitorDeviceName}  />
        <DetailPanelData id='DetectionLimitHeader' title="DETECTION LIMIT" data={leakMonitorDeviceDetectionLimit}  />
        <DetailPanelData id='AlarmSetPointHeader' title="ALARM SET POINT" data={leakMonitorDeviceAlarmSetPoint}  />
        <DetailPanelData id='ConcentrationMonitorTypeHeader' title="CONCENTRATION MONITOR TYPE" data={leakMonitorDeviceConcentrationMonitorType}  />
        <DetailPanelData id='ConcentrationMonitorManufacturerHeader' title="CONCENTRATION MONITOR MANUFACTURER" data={leakMonitorDeviceConcentrationManufacturer}  />
        <DetailPanelData id='SensorTypeHeader' title="SENSOR TYPE" data={leakMonitorDeviceSensorType}  />
        <DetailPanelData id='NumberOfSensorsHeader' title="NUMBER OF SENSORS" data={leakMonitorDeviceNumberOfSensors}  />
    </>
    );
};

LeakMonitoringDevice.propTypes = {
    data: PropTypes.object.isRequired
};

export default LeakMonitoringDevice;